const getHubSettings = state => state.hubSettings || {};
export const getHubSetting = (state, key) => {
  const settings = getHubSettings(state);
  return settings[key];
};